import axios from '../http'

function add(data) {
    return axios.post('/basedata/groupDoc/add', data);
}

function del(data) {
    return axios.post('/basedata/groupDoc/del', data);
}

function update(data) {
    return axios.post('/basedata/groupDoc/update', data);
}

function query(data) {
    return axios.post('/basedata/groupDoc/query', data);
}

function get(id) {
    return axios.get('/basedata/groupDoc/get?id=' + id);
}

function valid(data) {
    return axios.post('/basedata/groupDoc/valid', data);
}
function invalid(data) {
    return axios.post('/basedata/groupDoc/invalid' , data);
}

function getOptions(data) {
    return axios.post('/basedata/groupDoc/getOptions', data);
}

export default {
    add,
    del,
    update,
    query,
    get,
    valid,
    invalid,
    getOptions
}